// src/sagas/artistSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_ARTIST_PROFILE_REQUEST,
  UPDATE_ARTIST_PROFILE_REQUEST,
} from "../actions/types";
import {
  fetchArtistProfileSuccess,
  fetchArtistProfileFailure,
  updateArtistProfileSuccess,
  updateArtistProfileFailure,
} from "../actions/artistActions";
import { saveLibraryCardToApi } from "../apis/libraryCardApi";
import { fetchPublicProfile } from "../apis/publicApi";
import { getTenantId, getOwnerTenantId } from "../utils/authUtils";

function* fetchArtistProfileSaga(action) {
  try {
    const tenantId = action.payload?.tenantId || getOwnerTenantId();
    const card = yield call(fetchPublicProfile, { tenantId });
    const profile = card?.payload
      ? typeof card.payload === "string"
        ? JSON.parse(card.payload)
        : card.payload
      : null;
    yield put(fetchArtistProfileSuccess(profile));
  } catch (err) {
    console.error("artistSaga - fetchArtistProfile error:", err);
    yield put(fetchArtistProfileFailure(err.message));
  }
}

function* updateArtistProfileSaga(action) {
  try {
    const tenantId = getTenantId();
    const input = {
      tenantId,
      entityType: "ARTISTPROFILE",
      entityId: tenantId,
      payload: JSON.stringify(action.payload),
    };
    const result = yield call(saveLibraryCardToApi, input);
    if (!result?.success) throw new Error(result?.message || "Save failed");
    yield put(updateArtistProfileSuccess(action.payload));
  } catch (err) {
    console.error("artistSaga - updateArtistProfile error:", err);
    yield put(updateArtistProfileFailure(err.message));
  }
}

export default function* artistSaga() {
  yield takeLatest(FETCH_ARTIST_PROFILE_REQUEST, fetchArtistProfileSaga);
  yield takeLatest(UPDATE_ARTIST_PROFILE_REQUEST, updateArtistProfileSaga);
}
